<div class="modal-header">
  <button type="button"
          *ngIf="dialogConfig.dissmissable"
          class="btn-close"
          (click)="onCloseClicked()"
          aria-label="Close">
    <span class="visually-hidden"
          [translate]="'SHARED.DIALOGS.YES-NO-DIALOG.BUTTON-DISMISS'"></span>
  </button>
</div>

<div class="modal-body"
     [ngClass]="dialogConfig.modalBodyClass">
  <div class="text-center"
       *ngIf="dialogConfig.showIcon">
    <i-feather [name]="dialogConfig.iconClass"
               class="dvi-icon-color xl mb-4"></i-feather>
  </div>

  <span class="text-center pre-wrap"
        *ngIf="!dialogConfig.acceptHTML">
    <p class="m-0">{{ messageTranslationKey | translate: messageTranslationKeyArgs}}</p>
  </span>

  <span class="text-center"
        *ngIf="dialogConfig.acceptHTML">
    <p class="m-0"
       [innerHTML]="messageTranslationKey | translate: messageTranslationKeyArgs"></p>
  </span>
</div>

<div class="modal-footer"
     [ngClass]="{'justify-content-between': dialogConfig.cautionMode,
    'flex-row-reverse': dialogConfig.invertButtonsOrder}">
  <button (click)="noClicked()"
          type="button"
          class="btn btn-link px-4 text-end">
    <span> {{dialogConfig.noButtonTextTranslationKey | translate }} </span>
  </button>
  <button (click)="yesClicked()"
          type="button"
          class="btn btn-link px-4 text-end"
          [ngClass]="{'text-danger': dialogConfig.cautionMode}">
    <span> {{dialogConfig.yesButtonTextTranslationKey | translate }} </span>
  </button>
</div>
